document.addEventListener("DOMContentLoaded", (event) => {
  const buttons = document.querySelectorAll(".product__media-toggle");
  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", () => {
      const modal = document.querySelector(buttons[i].getAttribute('data-modal'));
      if (modal) {
        modal.setAttribute('open', 1);
        document.querySelector('html.js').classList.add('overflow_hidden');

        const modalSlider = document.querySelector('.main-carousel');

        // Delay Flickity init until after first paint
        requestAnimationFrame(() => {
          const modal_slider = new Flickity(modalSlider, {
            freeScroll: false,
            pageDots: false,
            contain: true,
            cellAlign: 'left'
          });
          modal_slider.select(i, true, true);
        });
      }
    });
  }
  
  // Auto-load first video on PDP if it exists
  // Note: Autoplay may fail on Safari without user interaction, but video will load and poster will be available
  setTimeout(() => {
    const firstVideoSlide = document.querySelector('.product__media-item[data-media-type="video"]');
    if (firstVideoSlide) {
      const deferredMedia = firstVideoSlide.querySelector('deferred-media');
      if (deferredMedia && !deferredMedia.getAttribute('loaded')) {
        // Load the video (autoplay will be attempted, but if it fails, poster remains visible)
        deferredMedia.loadContent(false);
      }
    }
  }, 300);
});

//After Pay Trigger
if(document.querySelector('.product-afterpay--trigger')) {
  let afterpayTrigger = document.querySelector('.product-afterpay--trigger');
  afterpayTrigger.addEventListener('click', function() {
    let popupElement = document.querySelector('square-placement');
    if(popupElement) {
      let button = popupElement.shadowRoot.querySelector('button');
      button.click();
    }
  });
}

// Klaviyo BIS Trigger in variant selector popup .sold-out boxes
// These buttons have duplicate id="BIS_trigger" so Klaviyo never binds to them.
// Delegate clicks to the actual (first) #BIS_trigger that Klaviyo is bound to.
document.querySelectorAll('.product_size_variant_popup .sold-out [js-bis-trigger]').forEach((btn) => {
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const actualBISTrigger = document.querySelector('#BIS_trigger');
    if (actualBISTrigger) actualBISTrigger.click();
  });
});


function openBISPopup() {
  const iframe = document.getElementById('BIS_frame');
  if (!iframe) {
    console.warn('[BIS] iframe not found');
    return;
  }

  iframe.style.display = 'block';

  // Wait until iframe document is ready
  const tryOpen = () => {
    try {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      if (!doc || !doc.body) return false;

      doc.body.classList.add('fadein', 'bis-popover-active');
      return true;
    } catch (err) {
      console.warn('[BIS] iframe not ready yet');
      return false;
    }
  };

  // Try immediately
  if (tryOpen()) return;

  // Retry for async-loaded iframe
  let attempts = 0;
  const interval = setInterval(() => {
    if (tryOpen() || attempts > 20) {
      clearInterval(interval);
    }
    attempts++;
  }, 50);
}

//Fit Finder Popup Content
if(document.querySelector('.fit-finder')) {
  document.querySelector('.fit-finder').addEventListener('click', function (event) {
    event.preventDefault();
    let url = this.getAttribute('href');
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(fitFinderHtml => {
      let newElement = document.createElement('div');
      newElement.innerHTML = fitFinderHtml;
      let getFitFinderPageDetaile = newElement.querySelector('main#MainContent');
      if (getFitFinderPageDetaile) {
        let getFitFinderPageHtml = getFitFinderPageDetaile.outerHTML;
        document.querySelector('.fit_finder_popup .fit_finder_content').innerHTML = getFitFinderPageHtml;
        document.querySelector('.fit_finder_popup').classList.add('open');

        let scripts = newElement.querySelectorAll('script');
        scripts.forEach(script => {
          let newScript = document.createElement('script');
          if (script.src) {
            newScript.src = script.src;
          } else {
            newScript.textContent = script.textContent;
          }
          document.body.appendChild(newScript);
        });
      }
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
  });
}
//Fit Finder Close Button
if(document.querySelector('.fitfinder_close')) {
  document.querySelector('.fitfinder_close').addEventListener('click', function (event) {
    document.querySelector('.fit_finder_popup').classList.remove('open');
  })
}

if (document.getElementById("selected_color_label") && document.getElementById("selected_color_label").getAttribute("color_swatch_group_available")) {
  const color_swatch_options_li = document.querySelectorAll(".color-swatch-element");
  for (let i = 0; i < color_swatch_options_li.length; i++) {
    color_swatch_options_li[i].addEventListener("mouseover", function(){
      let color_name = color_swatch_options_li[i].getAttribute("color-name");
      if(color_swatch_options_li[i].parentElement.querySelector(".color-swatch-group-label")){
        let closest_swatch_group_label = color_swatch_options_li[i].parentElement.querySelector(".color-swatch-group-label");
        closest_swatch_group_label.querySelector(".hover_color_label").innerHTML = color_name;
        closest_swatch_group_label.querySelector(".current_color_label").style.display = "none";
        closest_swatch_group_label.querySelector(".hover_color_label").style.display = "inline-block";
      }
    });
    color_swatch_options_li[i].addEventListener("mouseout", function(){
      if(color_swatch_options_li[i].parentElement.querySelector(".color-swatch-group-label")){
        let closest_swatch_group_label = color_swatch_options_li[i].parentElement.querySelector(".color-swatch-group-label");
        closest_swatch_group_label.querySelector(".current_color_label").style.display = "inline-block";
        closest_swatch_group_label.querySelector(".hover_color_label").style.display = "none";
      }
    });
  }
}

function add_complementary_product(obj) {
  let complementaryProductSizeSelector = obj.parentElement.querySelector('.complementary_product_size_selector_block');
  let complementaryProductSizeSelectorListsOne = complementaryProductSizeSelector.querySelectorAll('.multiple_size_option');
  let complementaryProductSizeSelectorListsTwo = complementaryProductSizeSelector.querySelectorAll('.multiple_size_option.multiple_sizes_list');
  let values = [];
  complementaryProductSizeSelectorListsOne.forEach(function(complementaryProductSizeSelectorList) {
    let complementarySizeName = complementaryProductSizeSelectorList.getAttribute('data-attr');
    values.push(complementarySizeName);
  });
  let sizeConcatenatedValues = values.join(' / ');

  let complementaryProductSizeList = obj.parentElement.querySelector('.complementary_product_size_selector');
  let complementaryProductSizeListOptions = complementaryProductSizeList.querySelector('option[data-varianttitle="' + sizeConcatenatedValues + '"]');
  if (complementaryProductSizeListOptions) {
    let variant_id = complementaryProductSizeListOptions.value;
    const isPreorder = obj.getAttribute('data-preorder') === 'true';
    if (isPreorder) {
    const preorderValue = obj.getAttribute('data-preorder-value');
      let props = {};
      props["Preorder"] = preorderValue;
      window.theme.addToCart({
      id: variant_id,
      quantity: 1,
      properties: props
    });
    }
    else{
      window.theme.addToCart({
      id: variant_id,
      quantity: 1
    });
    }
    
    
  }

  complementaryProductSizeSelectorListsTwo.forEach(function(complementaryProductSizeSelectorListTwo) {
    let sizeName = complementaryProductSizeSelectorListTwo.getAttribute('data-attr');
    if(sizeName == "") {
      obj.parentElement.querySelector(".custom_variant_selector__error").classList.remove('hidden');
    } else {
      obj.parentElement.querySelector(".custom_variant_selector__error").classList.add('hidden');
    }
  });
}

//Complementary Size Select Popup
function complementary_product_variant_size_selector_popup_show(object) {
  object.parentElement.querySelector(".complementary_product_size_selector_popup").classList.add('active');
}

function complementary_size_variant_popup_close(object) {
  object.closest('.complementary_product_size_selector_popup').classList.remove('active');
}

function getOptionValue(getSize) {
  let selectedValue = getSize.getAttribute('data-value');
  let parentOption = getSize.closest('.multiple_size_option');
  parentOption.setAttribute('data-attr', selectedValue);

  let sizeSiblings = Array.from(parentOption.querySelectorAll('span'));
  sizeSiblings.forEach(function(sizeSibling) {
    sizeSibling.classList.remove('active');
  });
  getSize.classList.add('active');

  const errorElement = getSize.parentElement.querySelector(".custom_variant_selector__error");
  if (errorElement && !errorElement.classList.contains('hidden')) {
    errorElement.classList.add('hidden');
  }

  let getSizeParentElement = getSize.closest(".complementary_product_size_list");
  let getSizeLength = getSizeParentElement.querySelectorAll('.multiple_size_option.multiple_sizes_list');

  if(getSizeLength.length == 1) {
    getSize.closest('.complementary_product_size_selector_popup').classList.remove('active');
    let getSizeParentElementTwo = getSize.closest('.complementary_product_size_selector_block');
    let getSizeParentElementBox = getSizeParentElementTwo.querySelector('.complementary_product_variant_size_select .complementary_selected_size');
    getSizeParentElementBox.innerHTML = getSize.innerHTML;
  }
}

//Drop Hint PopupModal
if(typeof recipientName == 'undefined') {
  let recipientName = document.querySelector('input#recipient-name');
  if(recipientName) {
    recipientName.addEventListener('input', function () {
      let recipientNameValue = recipientName.value;
      document.querySelector('.recipientName').innerHTML = recipientNameValue;
    });
  }
}
if(typeof yourName == 'undefined') {
  let yourName = document.querySelector('input#your-name');
  if(yourName) {
    yourName.addEventListener('input', function () {
      let yourNameValue = yourName.value;
      document.querySelector('.recipientNameTwo').innerHTML = yourNameValue;
    });
  }
}

//Band and Cup Size Mobile
if(typeof bandSize == "undefined" || typeof cupSize == "undefined"){
  const bandSize = document.querySelector('.product-form__input.band');
  let bandCupMobile = window.matchMedia('(max-width: 749px)');
  if (bandCupMobile.matches) {
    if(bandSize) {
      let bandSizeSelect = bandSize.querySelector('.product-form__input.band .popup_size_variant_lists');
      let cupSize = document.querySelector('.product-form__input.cup');
      let cupSizeSelect = cupSize.querySelector('.product-form__input.cup .popup_size_variant_lists');

      let bandParentOption = bandSize.querySelector('.bandcup_band .bandcup_multiple_size_variant_list');
      let bandSizeList = bandSize.querySelectorAll('.bandcup_band .bandcup_multiple_size_variant_list span');
      let disabledBandSizeList = bandSize.querySelectorAll('.bandcup_band .bandcup_multiple_size_variant_list span.band_disabled_size');
      let disabledCupSizeList = bandSize.querySelectorAll('.bandcup_multiple_size_option .bandcup_multiple_size_variant_list span.band_disabled_size');

      bandSizeList.forEach(function(band_Size_List) {
        band_Size_List.addEventListener("click", (event) => {
          let bandSizeValue = band_Size_List.getAttribute('data-sizevalue');
          bandSizeSelect.querySelector('input[type=radio][value="' + bandSizeValue + '"]').click();

          let bandSizeSiblings = Array.from(bandParentOption.querySelectorAll('span'));
          bandSizeSiblings.forEach(function(bandSizeSibling) {
            bandSizeSibling.classList.remove('active');
          });
          band_Size_List.classList.add('active');

          if (disabledCupSizeList && Array.from(disabledCupSizeList).some(el => el.classList.contains('active'))) {
            bandSize.querySelector('.mobile_size_popup_add_cart').classList.add('hidden');
          } else {
            bandSize.querySelector('.mobile_size_popup_add_cart').classList.remove('hidden');
          }
        });
      });

      let cupParentOption = bandSize.querySelector('.bandcup_cup .bandcup_multiple_size_variant_list');
      let cupSizeList = bandSize.querySelectorAll('.bandcup_cup .bandcup_multiple_size_variant_list span');

      cupSizeList.forEach(function(cup_Size_List) {
        cup_Size_List.addEventListener("click", (event) => {
          let cupSizeValue = cup_Size_List.getAttribute('data-sizevalue');
          cupSizeSelect.querySelector('input[type=radio][value="' + cupSizeValue + '"]').click();

          let cupSizeSiblings = Array.from(cupParentOption.querySelectorAll('span'));
          cupSizeSiblings.forEach(function(cupSizeSibling) {
            cupSizeSibling.classList.remove('active');
          });
          cup_Size_List.classList.add('active');

          if (disabledBandSizeList && Array.from(disabledBandSizeList).some(el => el.classList.contains('active'))) {
            bandSize.querySelector('.mobile_size_popup_add_cart').classList.add('hidden');
          } else {
            bandSize.querySelector('.mobile_size_popup_add_cart').classList.remove('hidden');
          }
        });
      });

      if(disabledCupSizeList) {
        disabledCupSizeList.forEach(function(disabled_cup_Size_List) {
          disabled_cup_Size_List.addEventListener("click", (event) => {
            bandSize.querySelector('.mobile_size_popup_add_cart').classList.add('hidden');
          });
        });
      }
      cupSize.querySelector('.product_variant_size_select').addEventListener("click", (event) => {
        bandSize.querySelector('.product_size_variant_popup').classList.add('active');
        bandSize.querySelector('.size_popup_overlay ').classList.add('opacity-100');
        cupSize.querySelector('.product_size_variant_popup').classList.remove('active');
        cupSize.querySelector('.size_popup_overlay ').classList.remove('opacity-100');
      });
    }
  }
}

// SizeGuide Modal js
if(document.querySelector('.sizeguide_text a[data-open="sizing-modal"]')) {
  document.querySelector('.sizeguide_text a[data-open="sizing-modal"]').addEventListener('click', function (event) {
    document.querySelector('div#sizing-modal').style.display = "block";
    document.querySelector('body').classList.add('is-sizeguide-open');
    document.querySelector('.sizeguide_overlay').classList.remove('hidden');
  });
}
if(document.querySelector('div#sizing-modal a.close-button')) {
  document.querySelector('div#sizing-modal a.close-button').addEventListener('click', function (event) {
    document.querySelector('div#sizing-modal').style.display = "none";
    document.querySelector('body').classList.remove('is-sizeguide-open');
    document.querySelector('.sizeguide_overlay').classList.add('hidden');
  });
}
if(document.querySelector('.sizeguide_overlay')) {
  document.querySelector('.sizeguide_overlay').addEventListener('click', function (event) {
    document.querySelector('div#sizing-modal').style.display = "none";
    document.querySelector('.sizeguide_overlay').classList.add('hidden');
  });
}


if(typeof productsizeguides == "undefined") {
  const productsizeguides = document.querySelectorAll('.sizeguide_text a[data-open="sizing-modal"]');
  if(productsizeguides){
    productsizeguides.forEach(sizeguide => {
      sizeguide.addEventListener('click', (e) => {
        document.querySelector('div#sizing-modal').style.display = "block";
      })
    })
  }
}

if(typeof tabs == "undefined") {
  const tabs = document.querySelectorAll('[data-tab-target]');
  const tabContents = document.querySelectorAll('[data-tab-content]');

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
    e.preventDefault();
      let target = document.querySelector(tab.dataset.tabTarget)
      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active')
      })
      tabs.forEach(tab => {
        tab.classList.remove('active')
      })
      tab.classList.add('active')
      target.classList.add('active')
    })
  })
}

/* Unified Touch/Click Event Handler
 * Handles both touch and click events to eliminate mobile touch latency
 * Prevents double-firing by tracking touch events
 */
function handleInteraction(element, callback, options = {}) {
  if (!element) return;
  
  let touchHandled = false;
  let touchStartTime = 0;
  
  // Handle touch events for mobile
  element.addEventListener('touchstart', function(e) {
    touchStartTime = Date.now();
    if (options.preventDefault) {
      e.preventDefault();
    }
    touchHandled = true;
    callback(e);
  }, { passive: !options.preventDefault });
  
  // Handle click events for desktop (and as fallback)
  element.addEventListener('click', function(e) {
    // If touch was handled recently (within 500ms), ignore click to prevent double-firing
    if (touchHandled && (Date.now() - touchStartTime < 500)) {
      touchHandled = false;
      if (options.preventDefault) {
        e.preventDefault();
      }
      return;
    }
    if (options.preventDefault) {
      e.preventDefault();
    }
    callback(e);
  });
}

/* Variant Selections
Used on QuickAdd and PDP
*/
document.querySelectorAll('product-info').forEach(function(productInfoElement) {
  let sectionId = productInfoElement.dataset.section

      //Variant Size Select Popup
      if(typeof variantSelectSizes == "undefined") {
        let variantSelectSizes = document.querySelectorAll('.product-form__input');
        variantSelectSizes.forEach(variantSelectSize => {
          let selectedSize = variantSelectSize.querySelector('span.selected_size');
          let selectedSizeSticky = variantSelectSize.querySelector('span[data-selected-size-sticky]');
          let mobileStickyAddBox = variantSelectSize.querySelector('.mobile_sticky_add_box');
          let selectedSizeClosed = variantSelectSize.querySelector('.size_variant_popup_close');
          if(selectedSize){
            let productURL = window.location.href;
            if(productURL.indexOf('?variant') !== -1 ) {
              selectedSize.style.textTransform = 'uppercase';
              let mobileView = window.matchMedia('(max-width: 749px)');
              if (mobileView.matches) {
                if(variantSelectSize.querySelector('.product_variant_size_select').classList.contains('mobile_size_variant_hidden')){
                  variantSelectSize.querySelector('.product_variant_size_select.mobile_size_variant_hidden').classList.add('active');
                }
              }
            } else {
              selectedSize.innerHTML = 'Select a Size';
            }
            handleInteraction(selectedSize, function (e) {
              e.preventDefault();
              e.stopPropagation();
              let sizeParent = selectedSize.closest('.product-form__input');
              let sizeListBlock = sizeParent.querySelector('.product_size_variant_popup');
              variantSelectSize.querySelector('.size_popup_overlay').classList.add('opacity-100');
              sizeListBlock.classList.add('active');
              document.querySelector('.product__media-wrapper').classList.add('z-index-1');
              document.body.classList.add('size-popup-open');
              
              // Prevent clicks inside the modal from bubbling to overlay
              // But allow the close button and interactive elements to work normally
              if (sizeListBlock) {
                const stopPropagation = function(e) {
                  // Don't stop propagation for the close button or other interactive elements
                  const target = e.target;
                  if (target.closest('.size_variant_popup_close') || 
                      target.closest('button') || 
                      target.closest('input[type="radio"]') ||
                      target.closest('label')) {
                    return;
                  }
                  e.stopPropagation();
                };
                // Use bubbling phase so close button handlers fire first
                sizeListBlock.addEventListener('click', stopPropagation, false);
                sizeListBlock.addEventListener('touchstart', stopPropagation, false);
              }
            }, { preventDefault: true });
          }
          // Make the sticky selected-size label tappable so users can change size from the sticky bar
          if(selectedSizeSticky) {
            handleInteraction(selectedSizeSticky, function (e) {
              e.preventDefault();
              e.stopPropagation();
              let sizeParent = selectedSizeSticky.closest('.product-form__input');
              let sizeListBlock = sizeParent.querySelector('.product_size_variant_popup');
              variantSelectSize.querySelector('.size_popup_overlay').classList.add('opacity-100');
              sizeListBlock.classList.add('active');
              document.querySelector('.product__media-wrapper').classList.add('z-index-1');
              document.body.classList.add('size-popup-open');
            }, { preventDefault: true });
          }
          if(selectedSizeClosed) {
            handleInteraction(selectedSizeClosed, function (e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              let sizeParent = selectedSizeClosed.closest('.product-form__input');
              let sizeListBlock = sizeParent.querySelector('.product_size_variant_popup');
              sizeListBlock.classList.remove('active');
              variantSelectSize.querySelector('.size_popup_overlay').classList.remove('opacity-100');
              document.querySelector('.product__media-wrapper').classList.remove('z-index-1');
              document.body.classList.remove('size-popup-open');
              if(variantSelectSize.querySelector('.product_variant_size_select').classList.contains('mobile_size_variant_hidden')){
                variantSelectSize.querySelector('.product_variant_size_select.mobile_size_variant_hidden').classList.add('active');
              }
            }, { preventDefault: true });
          }
          let popup_size_variant_lists_label = variantSelectSize.querySelectorAll('.popup_size_variant_lists input[type=radio]');
          popup_size_variant_lists_label.forEach((variantLabel) => {
            handleInteraction(variantLabel, function (event) {
              // Ensure the radio button is actually checked
              variantLabel.checked = true;
              
              // Trigger change event to ensure VariantSelects class receives it
              variantLabel.dispatchEvent(new Event('change', { bubbles: true }));
              
              // Also trigger click event on the variant-radios element to ensure onVariantChange is called
              const variantRadios = variantLabel.closest('variant-radios');
              if (variantRadios) {
                variantRadios.dispatchEvent(new Event('click', { bubbles: true }));
              }
              
              if (selectedSizeSticky) selectedSizeSticky.innerHTML = variantLabel.value;
              selectedSize.innerHTML = variantLabel.value;
              selectedSize.style.textTransform = "uppercase";
              let popupSizeVariantLists = variantLabel.closest('.product_size_variant_popup');
              let desktopView = window.matchMedia('(min-width: 750px)');
              if (desktopView.matches) {
                popupSizeVariantLists.classList.remove('active');
              }
            }, { preventDefault: false });
          });

          let addToCartButtons = variantSelectSize.querySelectorAll('.mobile_size_popup_add_cart button, .mobile_sticky_add_box button');
          let btnAddToBagForm = document.querySelector(`button#ProductSubmitButton-${sectionId}`);
          addToCartButtons.forEach(addToCartButton => {
            handleInteraction(addToCartButton, function (event) {
              event.preventDefault();
              if (btnAddToBagForm) {
                btnAddToBagForm.click();
                setTimeout(() => {
                  let popup = addToCartButton.closest('.product_size_variant_popup');
                  if (popup) {
                    popup.classList.remove('active');
                  }
                  variantSelectSize.querySelector('.size_popup_overlay').classList.remove('opacity-100');
                  document.querySelector('.product__media-wrapper').classList.remove('z-index-1');
                  document.body.classList.remove('size-popup-open');
                  if(document.querySelector('.product-form__input.size .product_variant_size_select').classList.contains('mobile_size_variant_hidden')){
                    document.querySelector('.product-form__input.size .product_variant_size_select.mobile_size_variant_hidden').classList.add('active');
                  }
                  // Ensure button state is updated after modal closes
                  if (btnAddToBagForm) {
                    btnAddToBagForm.removeAttribute('aria-disabled');
                  }
                }, 1000);
              }
            }, { preventDefault: true });
          });
          
          // Handle clicks on all size option spans in gift set popup (not just band/cup)
          let allSizeOptionSpans = variantSelectSize.querySelectorAll('.bandcup_multiple_size_option .bandcup_multiple_size_variant_list span');
          allSizeOptionSpans.forEach(function(sizeSpan) {
            sizeSpan.addEventListener("click", (event) => {
              event.preventDefault();
              event.stopPropagation();
              
              let sizeValue = sizeSpan.getAttribute('data-sizevalue');
              if (!sizeValue) return;
              
              // Trim whitespace from size value
              sizeValue = sizeValue.trim();
              
              // Find which option this span belongs to by looking at the parent's label
              let parentOption = sizeSpan.closest('.bandcup_multiple_size_option');
              if (!parentOption) return;
              
              let optionLabel = parentOption.querySelector('label');
              if (!optionLabel) return;
              
              // Get the option name from the label (e.g., "Select Sheer Tulle Thong (Size) :")
              let optionName = optionLabel.textContent.trim();
              // Extract the option name (remove "Select" and ":" and trim)
              optionName = optionName.replace(/^Select\s+/i, '').replace(/\s*:\s*$/, '').trim();
              
              // Find the radio button with matching name and value across ALL fieldsets
              let allRadioButtons = document.querySelectorAll('variant-radios input[type="radio"]');
              let radioButton = null;
              
              allRadioButtons.forEach(function(radio) {
                // Match by name attribute (which contains the option name) and value
                if (radio.name === optionName && radio.value.trim() === sizeValue) {
                  radioButton = radio;
                }
              });
              
              if (radioButton) {
                radioButton.click();
                radioButton.checked = true;
                
                // Trigger change event to update variant
                radioButton.dispatchEvent(new Event('change', { bubbles: true }));
                
                // Update active state on spans in ALL popups (since they all show the same spans)
                let allPopups = document.querySelectorAll('.product_size_variant_popup');
                allPopups.forEach(function(popup) {
                  // Find the matching span in this popup for the same option
                  let allOptionDivs = popup.querySelectorAll('.bandcup_multiple_size_option');
                  allOptionDivs.forEach(function(optionDiv) {
                    let label = optionDiv.querySelector('label');
                    if (label && label.textContent.trim().replace(/^Select\s+/i, '').replace(/\s*:\s*$/, '').trim() === optionName) {
                      let matchingSpan = optionDiv.querySelector(`.bandcup_multiple_size_variant_list span[data-sizevalue="${CSS.escape(sizeValue)}"]`);
                      if (matchingSpan) {
                        let siblings = optionDiv.querySelectorAll('.bandcup_multiple_size_variant_list span');
                        siblings.forEach(function(sibling) {
                          sibling.classList.remove('active');
                        });
                        matchingSpan.classList.add('active');
                      }
                    }
                  });
                });
              }
            });
          });
        });
      }
      document.querySelectorAll('.size_popup_overlay').forEach(function(sizePopupOverlay) {
        handleInteraction(sizePopupOverlay, function (event) {
          // Only close if clicking directly on the overlay, not on the modal content
          const activePopup = document.querySelector('.product_size_variant_popup.active');
          if (activePopup && activePopup.contains(event.target)) {
            // Click is inside the modal, don't close
            return;
          }
          
          // Prevent event from reaching elements behind the overlay
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          if (activePopup) {
            activePopup.classList.remove('active');
            sizePopupOverlay.classList.remove('opacity-100');
            document.querySelector('.product__media-wrapper').classList.remove('z-index-1');
            document.body.classList.remove('size-popup-open');
            if(document.querySelector('.product-form__input.size .product_variant_size_select').classList.contains('mobile_size_variant_hidden')){
              document.querySelector('.product-form__input.size .product_variant_size_select.mobile_size_variant_hidden').classList.add('active');
            }
            
            // Ensure button state is updated after modal closes
            setTimeout(() => {
              const btnAddToBagForm = document.querySelector(`button#ProductSubmitButton-${sectionId}`);
              if (btnAddToBagForm) {
                // Check if a variant is selected
                const variantInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
                if (variantInput && variantInput.value) {
                  btnAddToBagForm.removeAttribute('aria-disabled');
                  btnAddToBagForm.style.display = 'block';
                }
              }
            }, 100);
          }
        }, { preventDefault: true });
      });

      //Mobile Stickty Size Option
      if(typeof floatSelectVariant == "undefined") {
        if(document.querySelector('.product-form__input.size')) {
          let floatSelectVariant = document.querySelector('.product-form__input.size .product_variant_size_select');
          let btnAddToBagForm = document.querySelector(`button#ProductSubmitButton-${sectionId}`);
          let addtocartoffset = btnAddToBagForm.offsetTop + 900;
          let addtocartoffsetTwo = btnAddToBagForm.offsetTop + 150;

          let desktopView = window.matchMedia('(max-width: 749px)');
          if (desktopView.matches) {
            window.addEventListener('scroll', () => {
              if (scrollY > addtocartoffsetTwo) {
                floatSelectVariant.classList.remove('mobile_size_variant_hidden');
              }else{
                floatSelectVariant.classList.add('mobile_size_variant_hidden');
              }
            });
            window.addEventListener('scroll', () => {
              if (scrollY > addtocartoffset) {
                floatSelectVariant.classList.add('mobile_size_variant_hidden');
              }
            });
          }
        }
      }
      if(typeof floatAddToCart == "undefined") {
        let floatAddToCart = document.querySelector('.mobile-sticky-atc');
        let addTocartMobile = document.querySelector('.mobile-sticky-atc #add-to-cart');
        let btnAddToBagForm = document.querySelector(`button#ProductSubmitButton-${sectionId}`);
        let addtocartoffset = btnAddToBagForm.offsetTop + 500;

        window.addEventListener('scroll', () => {
          if (scrollY > addtocartoffset) {
            floatAddToCart.classList.remove('mobileCart_hidden');
          } else {
            floatAddToCart.classList.add('mobileCart_hidden');
          }
        });

        addTocartMobile.addEventListener("click", (event) => {
          event.preventDefault();
          let addcarttext =  addTocartMobile.innerHTML;
          if(addcarttext == "Select Size") {
            document.querySelector(`#ProductCustomButton-${sectionId}`).scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
          } else {
            btnAddToBagForm.click('click');
            document.querySelector('.mobile-sticky-atc').classList.add('hidden');
          }
        });
      }

      if(typeof customAddToBag == "undefined") {
        const customAddToBag = document.querySelector(`#ProductCustomButton-${sectionId}`);
        if(customAddToBag){
          customAddToBag.addEventListener("click", (event) => {
            event.preventDefault();
            document.querySelector(`#custom_variant_selector__error-${sectionId}`).style.display = 'block';
          });
        }
      }

});
